<template>
  <a-form-item
    :label="data.fieldname"
    class="input-box clearfix"
    :class="{ 'en-input-box': isEnglish, 'isrepeatsave': isrepeatsave }"
  >
    <div
      v-decorator="[`${data.fieldkey}`, {
        validateTrigger: ['blur'],
        rules: [{
          required: data.isneeded === 1,
          message: placeholder
        }, {
          validator: validateRepeat,
          message: repeatTip
        }, {
          validator: checkNum,
          message: numberInputTip
        }, {
          validator: checkEmail
        }],
        initialValue: value
      }]"
      class="wrap"
    >
      <a-input
        v-model="value"
        :placeholder="placeholder"
        :disabled="data.disabled"
        class="input"
        @change="handleChange"
        @blur="handleBlur"
      />
      <a
        v-if="!isNumError && !isEmailError && isrepeat && is_show_view"
        href="javascript:;"
        class="look-repeat-btn"
        @click="handleClickRepeat"
      >{{ $t('message["85"]') }}</a>
      <i
        v-if="data.fieldtype === 'ip' && !isIpError && value"
        class="iconfont iconditu address-map"
        @click="mapVisible = true"
      />
      <MapModal
        v-if="data.fieldtype === 'ip' && !isIpError && mapVisible && value"
        :visible.sync="mapVisible"
        :ip="value"
        :fieldkey="data.fieldkey"
        :fieldtype="data.fieldtype"
      />
    </div>
  </a-form-item>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { checkRepeat } from '@/services/inqueryServices'
import { checkClueFieldRepeat } from '@/services/clue'

import MapModal from '@/components/pc/map/MapModal'
import { getLang } from '@/lib/storage'

export default {
  name: 'Input',
  components: {
    MapModal
  },
  inject: {
    myForm: {
      default: () => { }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    parentKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: '',
      isEmailError: false,
      isNumError: false,
      isIpError: false,
      isrepeat: 0,
      is_show_view: 0,
      isrepeatsave: 0,
      mapVisible: false,
      source: ''
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['repeatSaveItems']),

    inquiryId () {
      return this.$route.params.inquiryId || this.$route.params.id
    },
    pid () {
      return this.$route.params.pid
    },
    repeatTip () {
      return this.source === 'clue' && this.isClue ? '存在重复线索' : this.$t('message["134"]')
    },
    numberInputTip () {
      return this.$t('message["1601"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isClue () {
      return this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail'
    }
  },
  watch: {
    data: {
      handler (val) {
        if (val) {
          this.setDefault()
        }
      },
      deep: true,
      immediate: true
    }
  },
  destroyed () {
    this.UPDATE_REPEAT_SAVE_ITEMS({})
  },
  methods: {
    ...mapMutations('inquery/detailData', ['UPDATE_REPEAT_SAVE_ITEMS']),

    getLang,

    init () {
      this.setDefault()
    },
    handleChange (e) {
      const { fieldtype = '', fieldkey } = this.data || {}
      let val = e.target.value
      this.value = val
      if (fieldtype === 'email') {
        val = this.filterOutChinese(val).toLowerCase()
        this.value = val
      }
      if (fieldtype === 'phone' || fieldtype === 'email') {
        val = val.split(/[,，\s]+/)
        this.value = val && val.join(',')
      }
      if (fieldtype === 'number') {
        val = val.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[a-z]|e/gi, '')
        this.value = val
      }

      if (this.value === '' || (this.value && this.value.trim() === '')) {
        this.is_show_view = 0
        this.isrepeatsave = 0
        this.repeatSaveItems[fieldkey] = 0
        this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems))
      }

      this.$emit('change', this.value)
    },

    handleBlur () {
      let { fieldkey = '' } = this.data || {}
      this.myForm && this.myForm.setFieldsValue({
        [fieldkey]: this.value
      })
      this.myForm && this.myForm.validateFields([fieldkey], () => { })
    },
    async setDefault () {
      let { fieldvalue = '', fieldtype = '' } = this.data || {}

      if (fieldtype === 'phone' || fieldtype === 'email' || this.$toType(fieldvalue) === 'array') {
        if (Array.isArray(fieldvalue)) {
          this.value = fieldvalue.join(',')
        } else {
          this.value = fieldvalue
        }
      } else {
        this.value = fieldvalue
      }
    },
    async validateRepeat (rule, value, callback) {
      let { fieldkey = '', fieldvalue = '', fieldrepeat = 0 } = this.data || {}
      let error = false
      // const is = (fieldtype === 'phone' || fieldtype === 'email') && this.isClue

      fieldvalue = fieldvalue.trim()
      if (!fieldvalue || !fieldrepeat) return

      if (!value || !fieldrepeat) return
      let res = null
      if (this.isClue) {
        res = await checkClueFieldRepeat().params({
          clue_id: this.inquiryId,
          fieldkey: this.parentKey + '.' + fieldkey,
          fieldvalue: value
        }).fetch()
      } else {
        res = await checkRepeat().params({
          inquiryid: this.inquiryId,
          fieldkey,
          fieldvalue: value
        }).fetch()
      }
      const { payload = {} } = res && res.data
      const { isrepeat = 0, isrepeatsave = 0, source = '' } = payload
      error = isrepeat === 1
      this.isrepeat = isrepeat
      this.isrepeatsave = isrepeatsave
      this.is_show_view = payload.is_show_view || 0
      this.source = source
      this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems, {
        [fieldkey]: isrepeatsave
      }))

      if (value && error) {
        callback(rule.message)
        // return
      } else {
        callback()
      }
    },
    checkNum (rule, value, callback) {
      const { fieldconfig = {}, fieldtype, fieldvalue } = this.data
      const { isallowdecimals, isallowminus } = fieldconfig
      if (fieldtype !== 'number' || fieldvalue === '') {
        callback()
        return
      }
      if (!/^(?:0|-?(?:0\.\d*[1-9]|[1-9]\d*(?:\.\d*[0-9])?))$/.test(value)) { // 是数字，包含正负和小数
        rule.message = this.$t('message["805"]')
        callback(rule.message)
        this.isNumError = true
        return
      }
      if (!isallowminus) { // 禁止负数
        if (!/^(?:0|[1-9]\d*)(?:\.\d*[0-9])?$/.test(value)) {
          rule.message = this.$t('message["836"]')
          callback(rule.message)
          this.isNumError = true
          return
        }
      }
      if (!isallowdecimals) { // 禁止小数点
        if (!/^(?:0|-?[1-9]\d*)$/.test(value)) {
          rule.message = this.$t('message["832"]')
          callback(rule.message)
          this.isNumError = true
          return
        }
      }
      this.isNumError = false
      callback()
    },
    checkEmail (rule, value, callback) {
      const { fieldtype, fieldvalue } = this.data
      if (fieldtype !== 'email' || this.value === '') {
        callback()
        return
      }
      let err = false
      fieldvalue.forEach(item => {
        rule.message = ''
        if (!/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(item)) {
          // rule.message = '邮箱不是有效的邮箱格式'
          rule.message = this.$t('message["1508"]')
          err = err || true
          return false
        }
      })
      if (err) {
        this.isEmailError = true
        callback(rule.message)
      } else {
        this.isEmailError = false
        callback()
      }
      callback()
    },
    /* checkIp (rule, value, callback) {
      const { fieldtype, fieldvalue } = this.data
      if (fieldtype !== 'ip' || this.value === '') {
        callback()
        return
      }
      let err = false
      if (!/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(fieldvalue)) {
        rule.message = 'IP不是有效的IP格式'
        err = err || true
        this.isIpError = err
        callback(rule.message)
        return
      }

      this.isIpError = err
      callback()
    }, */
    filterOutChinese (str) {
      var temp = ''
      for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) > 0 && str.charCodeAt(i) < 255) || str[i] === '，') {
          temp += str.charAt(i)
        }
      }

      return temp
    },
    handleClickRepeat () {
      let { fieldkey, fieldvalue } = this.data
      let href = ''
      if (Array.isArray(fieldvalue)) {
        fieldvalue = fieldvalue.join(',')
      }
      /* const { href } = this.$router.resolve({
        path: 'inquery/repeat',
        query: {
          repeatfieldkey: fieldkey,
          repeatfieldvalue: fieldvalue
        }
      }) */
      if (this.source === 'clue') {
        const { parentKey } = this
        href = `${location.origin}/project/${this.pid}/inquery/clue?search_type=${parentKey}.${fieldkey}&kwd=${fieldvalue}`
      } else {
        href = `${location.origin}/project/${this.pid}/inquery/repeat?repeatfieldkey=${fieldkey}&repeatfieldvalue=${fieldvalue}`
      }
      var tempwindow = window.open()
      tempwindow.location = href
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box ::v-deep {
  .wrap {
    position: relative;
  }
  .look-repeat-btn {
    position: absolute;
    left: 90px;
    top: 35px;
    font-size: 13px;
    line-height: 1;
  }
  .ant-form-explain {
    font-size: 13px;
  }
  .address-map {
    position: absolute;
    top: 0;
    left: 334px;
    color: $gray3;
    font-style: normal;
    cursor: pointer;
  }
}
.en-input-box::v-deep {
  .look-repeat-btn {
    left: 200px !important;
  }
}
.isrepeatsave ::v-deep {
  .has-error .ant-form-explain {
    color: #f6a953;
  }
}
</style>
